<template>
    <v-main>
        <v-container fluid class="pa-0 ma-0">
            <router-view></router-view>
        </v-container>
    </v-main>
</template>

<script>
    export default {
        name: 'Content'
    }
</script>

<style scoped>
    .content {
        background-color: #f3f3f4;
    }

</style>
